/* tslint:disable */
/* eslint-disable */
/**
 * quarkus-webapp API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.36.51
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ClientId
 */
export interface ClientId {
    /**
     * 
     * @type {number}
     * @memberof ClientId
     */
    id?: number;
}

/**
 * Check if a given object implements the ClientId interface.
 */
export function instanceOfClientId(value: object): value is ClientId {
    return true;
}

export function ClientIdFromJSON(json: any): ClientId {
    return ClientIdFromJSONTyped(json, false);
}

export function ClientIdFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClientId {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
    };
}

export function ClientIdToJSON(value?: ClientId | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
    };
}

